<template>
  <div>
    <v-content class="z-app-content-light">
      <introduction></introduction>
    </v-content>
    <v-content class="z-app-content-deep">
      <why-section></why-section>
    </v-content>
    <v-content class="z-app-content-light">
      <comparison></comparison>
    </v-content>
  </div>
</template>

<script>
// import VueMarkdown from "vue-markdown";
import Introduction from "../components/introduction";
import WhySection from "../components/whysection";
import Comparison from "../components/comparison";

export default {
  name: "HomePage",
  components: { Introduction, WhySection, Comparison }
};
</script>
